import { ChevronRight } from "@mui/icons-material";
import { Box, IconButton, Link, Typography } from "@mui/material";

import React from "react";

interface ItemProps {
  children: React.ReactNode;
}

const Item: React.FC<ItemProps> = ({ children }) => {
  return (
    <Box display={"flex"} justifyContent={"space-between"} padding={2}>
      {children}
    </Box>
  );
};

const LoginSecurityInformation: React.FC = () => {
  return (
    <Box>
      <Typography color={"typography.secondary"} variant="h3" paddingY={2}>
        Segurança e Login
      </Typography>

      <Box
        display={"flex-column"}
        gap={2}
        sx={{
          border: "1px solid grey",
          borderRadius: "8px",
          borderColor: "#E9EBF0",
        }}
      >
        <Item>
          <Box>
            <Typography variant="body1">Senha</Typography>
            <Typography variant="caption" color={"typography.secondary"}>
              Alterar sua senha
            </Typography>
          </Box>

          <Link href={"profile/edit/password"}>
            <IconButton
              style={{
                color: "typography.disabled",
              }}
            >
              <ChevronRight />
            </IconButton>
          </Link>
        </Item>
      </Box>
    </Box>
  );
};

export default LoginSecurityInformation;
